import { RouteConfig } from "vue-router";

const NomenclatorRoutes: Array<RouteConfig> = [
  {
    path: "",
    redirect: {
      name: "Appointment Types",
    },
  },
  {
    path: "procedures-subtypes",
    name: "Subtypes nomenclator",
    component: () =>
      import("@/views/Settings/Nomenclators/SubtypesNomenclator.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "medical-locations",
    name: "Medical locations",
    component: () =>
      import("@/views/Settings/Nomenclators/MedicalLocations.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "ocupations",
    name: "Ocupations",
    component: () => import("@/views/Settings/Nomenclators/Ocupations.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "accessories",
    name: "Accessories",
    component: () => import("@/views/Settings/Nomenclators/Accessories.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "references",
    name: "References",
    component: () => import("@/views/Settings/Nomenclators/References.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "appointment_types",
    name: "Appointment Types",
    component: () =>
      import("@/views/Settings/Nomenclators/AppointmentTypes.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "procedure_status",
    name: "Procedure Status",
    component: () =>
      import("@/views/Settings/Nomenclators/ProcedureStatus.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "lead_status",
    name: "Lead Status",
    component: () => import("@/views/Settings/Nomenclators/LeadStatus.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "procedure_form",
    name: "Procedure Form",
    component: () =>
      import("@/views/Settings/Nomenclators/ProceduresForForm.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
];

export default NomenclatorRoutes;
